export default __webpack_public_path__ + "static/media/logoHeader.e384c2ae.png";